import { MedewerkerEx } from "../../.generated/licenties/licentiestypes";
import { target2field } from "../../shared/utils/target-to-field";
import { UiName, FieldMap } from "../../shared/types";

export function mapDlTargetToMedewerkersUiField(target: string): UiName | null {
  const map: FieldMap<MedewerkerEx> = {};

  return target2field(map, target);
}
